<template>
   <fragment>
      <TopNav />
      <main role="main" class="container">
         <br /><br />

         <div class="row">
            <!-- RESULTS COLUMN -->
            <div class="col-lg-12">
               <div class="sticky-too sticky-favorites">
                  <div class="row">
                     <!-- RESULTS HEADER -->
                     <div class="col-md-10 mb-3 results-header">
                        <h1>
                           My Favorites <small>{{ selectedCareers }} saved</small>
                        </h1>
                     </div>
                     <div class="col-md-2 mb-3 results-header text-right">
                        <SortMenu ref="sortMenu" :disabled="!careers.length" />
                     </div>
                  </div>
               </div>

               <!-- RESULT CARDS -->
               <div class="col-md-12 card-list-container card-career" role="list">
                  <div v-if="!careers.length" class="empty">
                     <img src="~@/assets/images/icon-empty.png" aria-hidden="true" />

                     <h1>You don’t have any Favorites.</h1>

                     <p>
                        Click a star next to a job role<br />
                        to create a Favorite.
                     </p>
                  </div>
                  <div v-else class="row row-cols-1 row-cols-md-4 card-deck">
                     <CareerCard
                        v-for="career in careers"
                        :key="career.jobRoleId + career.shortDomainName"
                        :career="career"
                     />
                  </div>
               </div>
            </div>
            <!-- end CARDS -->
         </div>
      </main>
   </fragment>
</template>

<script>
import TopNav from '@/components/TopNav';
import CareerCard from '@/components/CareerCard';
import SortMenu from '@/components/SortMenu';

export default {
   name: 'FavoritesPage',
   components: {
      TopNav,
      CareerCard,
      SortMenu,
   },
   data: function() {
      return {
         careers: [],
         selectedCareers: 0,
      };
   },
   created: function() {
      // watch Vuex for changes to the store (filters)
      this.unwatch = this.$store.watch(
         (state, getters) => [getters['favorites/count']],
         watched => {
            this.selectedCareers = watched[0];
         }
      );
   },
   beforeDestroy: function() {
      this.unwatch();
   },
   mounted: async function() {
      this.careers = this.$refs.sortMenu.sortCareers(this.$store.state.favorites.careers);
      this.selectedCareers = this.careers.length;

      this.$watch(
         () => this.$refs.sortMenu.sortOption,
         () => {
            this.careers = this.$refs.sortMenu.sortCareers(this.$store.state.favorites.careers);
         }
      );
   },
};
</script>



// WEBPACK FOOTER //
// src/components/FavoritesPage.vue